import { memo } from 'react';

import { SymbolSelector as SymbolSelectorComponent } from './SymbolSelector';
import type { SymbolSelectorProps } from './types';

export { SymbolSelectorAppearance, type SymbolSelectorProps } from './types';

const MemoizedSymbolSelector = memo(SymbolSelectorComponent) as typeof SymbolSelectorComponent;

/**
 * Symbol Selection component customizing the internal SearchSelect component
 *
 * (Be careful not conflate the **SymbolSelector** with the **SearchSelect** component!)
 * - both are complex (and heavily used) but SymbolSelect is a symbol-based wrapper around the useSearchSelect hook
 */
export const SymbolSelector = (props: SymbolSelectorProps) => {
  return <MemoizedSymbolSelector {...props} />;
};
